import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import {Card, CardActions, CardContent, Button, Toolbar, Typography} from '@material-ui/core';
import SelectMilestone from 'ImportedProcedureUpdateCreate/components/SelectMilestone';

function ImportedProcedureUpdateCreate(props) {
  const {
    cnsProcedure: {name},
    importedProcedure,
    onChangeMilestone,
    onSaveImportedProcedure,
  } = props;
  const pageTitle = useMemo(
    () => `${importedProcedure.id ? 'Edit:' : 'import:'} ${name}`,
    [importedProcedure, name],
  );

  return (
    <div>
      <Helmet title={pageTitle} defer={false} />
      <Toolbar>
        <Typography variant="h4">{pageTitle}</Typography>
      </Toolbar>
      <Card>
        <CardContent>
          <SelectMilestone value={importedProcedure.milestone} onChange={onChangeMilestone} />
        </CardContent>
        <CardActions>
          <Button
            variant="outlined"
            onClick={onSaveImportedProcedure}
            color="primary"
            disabled={!importedProcedure.milestone?.id}
          >
            {importedProcedure.id ? 'Update' : 'Import'}
          </Button>
        </CardActions>
      </Card>
    </div>
  );
}

ImportedProcedureUpdateCreate.propTypes = {
  importedProcedure: PropTypes.object.isRequired,
  cnsProcedure: PropTypes.object.isRequired,
  onSaveImportedProcedure: PropTypes.func.isRequired,
  onChangeMilestone: PropTypes.func.isRequired,
};

export default ImportedProcedureUpdateCreate;
